import axios from 'axios';
import { getPromoterToken } from '@/utils/promoter';

// 独立实例：避免通用拦截器注入健康报告 token、ps 或触发 App 登录。
const client = axios.create({
  baseURL: process.env.VUE_APP_PROMOTER_API_BASE || '',
  timeout: 60000,
  headers: { p: 'H5', v: '2.5.5' },
});
const prefix = '/healthy/open';

async function post(path, params, authenticated = false, query = {}) {
  // 与 utils/request.js 一致：Java 接口使用 JSON 请求体。
  const data = {
    ...params,
    platform: 'web_app',
    ...(authenticated ? { token: getPromoterToken() } : {}),
  };
  const response = await client.post(`${prefix}/${path}`, data, {
    params: query,
  });
  return response.data;
}

export default {
  sendSms(params) {
    return post('promoterSendSms', params);
  },
  login(params) {
    return post('promoterLogin', params);
  },
  orders({ page = 1, size = 20 } = {}) {
    // 分页字段随 token 一起放入 JSON 请求体，避免接口使用默认的第一页。
    // 保留 d，兼容使用该查询参数的接口版本。
    return post('appPromoterOrder', { page, size }, true, { d: JSON.stringify({ page, size }) });
  },
};
